export default __webpack_public_path__ + "assets/images/1.35e370.avif";